import { Component } from '@angular/core';
import { AsyncPipe, NgIf } from '@angular/common';
import { RouterLink, RouterOutlet } from '@angular/router';
import { MatIconButton } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatDivider } from '@angular/material/divider';
import { TranslateModule } from '@ngx-translate/core';
import { FooterComponent } from '../footer/footer.component';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../services/auth.service';
import { FeatureManagementService } from '../../services/feature-management.service';
import { Observable } from 'rxjs';


@Component({
  standalone: true,
  imports: [AsyncPipe, NgIf, RouterLink, RouterOutlet, MatIconButton, MatMenuModule, MatDivider, TranslateModule, FooterComponent],
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  identityProviderUrl: string = environment.identityProviderUrl;
  dataPortalApiUrl: string = environment.dataPortalApiUrl + '/docs';

  managerClaim$: Observable<boolean>;

  constructor(private _authService: AuthService, private _featureManagementService: FeatureManagementService) {
    this.managerClaim$ = _authService.getManagerClaims();
  }

  logout() {
    // flush out session storage when user logs out
    sessionStorage.removeItem('selectedIdpUsers');
    sessionStorage.removeItem('searchFilterKey');
    this._authService.logout();
  }
}
